import { AdminNav, type AdminTab } from '../../../components/admin/AdminNav';
import PublishButton from '../PublishButton';

const DesktopNav = ({ handleTabChange, activeTab, setShouldLoadIntent, setShouldLoadQna,
    isNeedPublish,
    setConfirmModal,
    confirmPublish,
    setActiveTab, }: any) => {

    const onSelect = (tab: AdminTab, e: React.MouseEvent<HTMLButtonElement>) => {
        if (tab === 'keytopic') return handleTabChange(tab, e, () => setShouldLoadIntent(true));
        if (tab === 'faq') return handleTabChange(tab, e, () => setShouldLoadQna(true));
        return handleTabChange(tab, e);
    };

    return (
        <AdminNav
            layout="vertical"
            activeTab={activeTab}
            onSelect={onSelect}
            footer={
                <PublishButton
                    isNeedPublish={isNeedPublish}
                    setConfirmModal={setConfirmModal}
                    confirmPublish={confirmPublish}
                    setActiveTab={setActiveTab}
                    setShouldLoadQna={setShouldLoadQna}
                    showIndicator={true}
                />
            }
        />
    )
}
export default DesktopNav;
